<template>
  <div class="market-main-industry">
    <div class="title">
      <span>广东省百强企业行业分布情况</span>
      <ElementSelect
        :val="year"
        :options="yearOptions"
        @val="
          (e) => {
            year = e;
          }
        "
      />
    </div>
    <div class="chart-con has-tab">
      <div class="chart-pie">
        <v-chart
          ref="pie3D-chart"
          id="pie3D-chart"
          class="pie3D-chart"
          v-show="tabIndex"
          :options="chartOption"
          @click="showDialog = true"
        />
        <v-chart
          ref="pie-chart3"
          id="pie-chart3"
          class="pie-chart3"
          v-show="!tabIndex"
          :options="chartOption"
          @click="showDialog = true"
        />
        <div :class="['chart-legend', { chart3d: tabIndex }]">
          <div class="legend-list3">
            <div class="legend-item" v-for="(item, i) in chartData" :key="i">
              <div class="name">
                <span class="color" :style="{ 'background-color': colors[i] }"></span>
                <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">
                  <span>
                    {{ item.name ? item.name : '-' }}
                  </span>
                  <div slot="content">
                    {{ item.name ? item.name : '-' }}
                  </div>
                </el-tooltip>
                <span v-else>
                  {{ item.name ? item.name : '-' }}
                </span>
              </div>
              <span class="num">
                {{ item.value }}
              </span>
              <span class="unit">%</span>
            </div>
          </div>
          <div class="pager-box" v-if="!tabIndex">
            <i :class="['el-icon-caret-top', { dis: pager.current <= 1 }]" @click="changePage(false)"></i>
            <div>
              {{ pager.current }}
              <span> / {{ pager.total }} </span>
            </div>
            <i :class="['el-icon-caret-bottom', { dis: pager.current >= pager.total }]" @click="changePage(true)"></i>
          </div>
        </div>
      </div>
    </div>
    <EleDialog :title="dialogTitle" :visible.sync="showDialog">
      <div class="filter-box">
        <ElementSelect
          :val="search.cityName"
          :options="optionCity"
          clearable
          @val="changeVal($event, 'cityName')"
          v-if="!apiName.includes('City')"
          size="middle"
        />
        <ElementSelect
          :val="search.year"
          :options="optionYear"
          clearable
          @val="changeVal($event, 'year')"
          v-else
          size="middle"
        />
        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" />
      </div>
      <ComTable
        :tableCol="tableCol"
        :tableData="tableData"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog>
  </div>
</template>

<script>
import $ from 'jquery';
import drawPie from '../chartJs/pieRose';
import drawPie3D from '../chartJs/pie3D';
import { getPieData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import echarts from 'echarts';
import ElementSelect from '../../../components/element-select';
import ComTable from '../../../components/ComTable';
import tmpData from '../tmpData';
import cityJson from '../cityJson';

const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2', '#58ecac'];
const colors = [
  '#00C9FF',
  '#0078ff',
  '#fcf5c2',
  '#58ecac',
  '#ff8c60',
  '#a280ff',
  '#ee6566',
  '#fac959',
  '#91cd74',
  '#3aa272',
  '#aae6ff',
];
export default {
  name: 'EconomicProductionPavilion',
  components: { ElementSelect, TabList, ComTable },
  data() {
    return {
      showDialog: false,
      dialogTitle: '',
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 22,
      },
      apiName: '',
      search: {
        cityName: '',
        year: '',
        enterpriseName: '',
      },
      optionCity: cityJson,
      optionYear: [
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
      ],
      colors,
      colors3D,
      year: 2023,
      yearOptions: [],
      tabIndex: 0,
      tabList: [
        {
          key: 0,
          label: '行业',
        },
        {
          key: 1,
          label: '产业',
        },
      ],
      pager: {
        current: 1,
        total: 2,
      },
      legendBox: null,
      chart: null,
      chartOption3D: null,
      chartOption: null,
      chartData: null,
    };
  },
  computed: {
    tableCol() {
      let col = [];
      switch (this.apiName) {
        case 'getSpecialNewEnterpriseList':
        case 'getLitterEnterpriseList':
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'cityName',
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 320,
              align: 'left',
            },
          ];
          break;
        case 'getMapCityEnList':
          col = [
            {
              label: '排行',
              param: 'ranking',
              maxWidth: 70,
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 300,
              align: 'left',
            },
            {
              label: '所属行业',
              param: 'industry',
              width: 160,
              align: 'left',
            },
            {
              label: '营收（万元）',
              param: 'businessIncome',
              width: 80,
              align: 'left',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  watch: {
    tabIndex(n) {
      // if (!n) {
      this.chart.off('click');
      this.chart.off('mouseover');
      this.chart.off('globalout');
      // }
      this.chart = null;
      this.chartOption = null;
      this.chartOption3D = null;
      this.$nextTick(() => {
        this.getData();
      });
    },
    year(n) {
      this.$nextTick(() => {
        this.getData();
      });
    },
    chartData(n) {
      this.pager.total = n?.length ? Math.ceil((n?.length * 20) / this.legendBox.clientHeight) : 0;
    },
    'pager.current'(n) {
      if (n) {
        let box = this.legendBox;
        let y = box.clientHeight * (n - 1);
        box.style.transform = `translateY(-${y > 0 ? y + 15 : y}px)`;
      }
    },
  },
  methods: {
    changePage(next) {
      let { current, total } = this.pager;
      if (next) {
        this.pager.current = current < total ? current + 1 : current;
      } else {
        this.pager.current = current > 1 ? current - 1 : current;
      }
    },
    getData() {
      this.chart =
        // this.tabIndex
        //   ? echarts.init(document.getElementById('pie3D-chart'))
        //   :
        echarts.init(document.getElementById('pie-chart3'));
      // this.$api.screen
      //   .getGDPPrivateEconomy({
      //     caliber: this.tabList[this.tabIndex].label,
      //     year: this.year,
      //   })
      //   .then((res) => {
      // let { data } = res.data;
      // let list = data.map((item) => {
      //   return {
      //     name: item.quotaName,
      //     value: item.total,
      //   };
      // });
      // this.chartData = list;
      // this.$nextTick(() => {
      //   this.setInterData();
      // });
      // });
      let data = tmpData['广东省百强企业行业分布情况'];
      let yearTemp = data.map((x) => x['年份']);
      this.yearOptions = yearTemp
        .filter((item, index) => {
          return yearTemp.indexOf(item) === index;
        })
        .map((x) => ({
          value: x,
          label: x,
        }));
      let list = data
        .filter((x) => x['年份'] === this.year)
        .map((item) => {
          return {
            name: item['所属行业'],
            value: item['计数'],
          };
        });
      while (list.length > this.colors.length) {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        this.colors.push('#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1));
      }
      this.chartData = list;
      this.$nextTick(() => {
        this.setInterData();
      });

      // getPieData().then(res => {
      //   let type = this.tabList[this.tabIndex].label;
      //   let data = res.RECORDS.filter(item => {
      //     return item['类型'] === type && item['年份'] == this.year;
      //   });
      //   console.log(data, '-')
      //   let list = data.map(item => {
      //     return {
      //       name: item['指标'],
      //       value: Number(item['总数'])
      //     }
      //   });
      //   this.chartData = list;
      //   this.$nextTick(() => {
      //     this.setInterData();
      //   })
      // })
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['pie-chart3'].clear();

        // if (this.tabIndex) {
        //   this.chartOption = drawPie3D(this.chartData, 0, this.chart);
        // } else {
        this.chartOption = drawPie(this.chartData, this.colors);
        // }
      });
    },
    changeVal(e, type) {
      this.search[type] = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.getData();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
      let box = $('.legend-list3');
      this.legendBox = box[0];
    });
  },
};
</script>

<style lang="less" scoped>
.market-main-industry {
  .chart-box();
  display: inline-block;

  /deep/ .tab-list {
    .tab-item {
      min-width: 60px !important;
    }
  }

  .chart-con {
    overflow: inherit;
  }

  .pie-bg {
    width: 331px;
    height: 198px;
    background: url('~img/home/pie-bg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: -45px;
    bottom: -5px;
    /*z-index: 2;*/
  }

  .chart-pie {
    display: flex;
    height: 100%;
  }

  #pie-chart3,
  #pie3D-chart {
    width: 245px;
    height: 100%;
  }

  .chart-legend {
    width: calc(100% - 245px);
    /*width: 50%;*/
    color: #fff;
    height: 200px;
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    // max-height: 160px;
    overflow: hidden;
    //.show-scroll-bg-trans();

    &.chart3d {
      justify-content: center;
      max-height: 200px;

      .legend-item {
        line-height: 30px;
        margin-bottom: 20px;
      }
    }

    .legend-list3 {
      height: calc(100% - 20px);
      transition: all 0.3s;
    }

    .pager-box {
      position: absolute;
      right: 0;
      bottom: 10px;
      .flex-center();
      padding-right: 10px;
      font-size: 12px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #87e6ff;
      line-height: 38px;

      div {
        letter-spacing: -2px;
        margin: 0 10px;

        span {
          color: rgba(135, 230, 255, 0.3);
        }
      }

      i {
        margin-top: 2px;
        cursor: pointer;

        &.dis {
          color: rgba(135, 230, 255, 0.3);
          cursor: not-allowed;
        }
      }
    }

    .legend-item {
      .flex-center();
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dcdcdc;
      /*line-height: 20px;*/
      margin-bottom: 10px;

      &:first-child {
        margin-top: 10px;
      }

      .name {
        width: 100px;
        .flex-center();

        span:last-child {
          width: calc(100% - 21px);
          .ellipsis();
        }
      }
    }

    .color {
      width: 15px;
      height: 11px;
      margin-right: 6px;
    }

    .num {
      width: 80px;
      font-size: 20px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #fff;
      line-height: 30px;
      margin: 0 5px 0 20px;
      text-align: right;
    }

    .unit {
      font-size: 12px;
    }
  }
}
</style>
